export const  EmployeeLeavesColumns = [
    "EmployeeCode",
    "Sickleave",
    "CasualLeave",
    "CompOff",
    "PrivilegeLeave"
]